import { render, staticRenderFns } from "./UserNode.vue?vue&type=template&id=8043aea4&scoped=true"
import script from "./UserNode.vue?vue&type=script&lang=js"
export * from "./UserNode.vue?vue&type=script&lang=js"
import style0 from "./UserNode.vue?vue&type=style&index=0&id=8043aea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8043aea4",
  null
  
)

export default component.exports